import React, { useEffect, useState } from "react";
import Select from "react-select";
import ReactPaginate from "react-paginate";
import trackingServices from "../../Services/trackingService";
import Loader from "../../Components/Loader";
import { reportService } from "../../Services/reportService";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap-v5";
import moment from "moment";
const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL;
let currentPage1 = 1;

const ProviderOption = [
  { value: "ALL", label: "All" },
  { value: "BOOKING_CONFIRMED", label: "Pick Up in progress" },
  { value: "SHIPMENT_AT_WAREHOUSE", label: "Export formalities in progress" },
  { value: "DEPARTED", label: "In transit" },
  { value: "ARRIVED", label: "Import formalities in progress" },
  { value: "DELIVERED", label: "Delivered" },
];

  const providerObj = {
    BOOKING_REQUESTED : "Booking Requested" ,
    BOOKING_CONFIRMED : "Pick Up in progress" ,
    SHIPMENT_AT_WAREHOUSE : "Export formalities in progress" ,
    DEPARTED : "In transit" ,
    ARRIVED : "Import formalities in progress" ,
    DELIVERED : "Delivered" ,
  };

const tableheader = {
    ALL : [
      { label: "Shipment Status", value: "job_status" },
      { label: "Tracking Date", value: "tracking_date", type : "date" },
      { label: "Expected Delivery Date", value: "expacted_date", type : "date" },
    ],
    BOOKING_CONFIRMED: [
      { label: "Expected Pick Up", value: "next_stage_expected_date", type : "date" },
      { label: "Transport Vendor", value: "transport_vendor", type :"arr" },
    ],
    SHIPMENT_AT_WAREHOUSE: [
      { label: "Expected Dep", value: "next_stage_expected_date", type : "date" },
      { label: "Export Vendor", value : "carrier_name" },
      { label: "Tracking No/ AWB No/ BL No", value : "m_awb_m_b_l" },
    ],
    DEPARTED: [
      { label: "Expected Arrival", value: "next_stage_expected_date", type : "date" },
      { label: "Export Vendor", value : "carrier_name", },
      { label: "Tracking No/ AWB No/ BL No", value : "m_awb_m_b_l", },
    ],
    ARRIVED: [
      { label: "Expected Delivery", value: "expacted_date", type : "date" },
      { label: "Destination Vendor", value: "destination_vendor" },
      { label: "Tracking No/ AWB No/ BL No", value : "m_awb_m_b_l" },
    ],
    DELIVERED: [
      { label: "Destination Vendor", value: "destination_vendor", type : "date" },
      { label: "Tracking No/ AWB No/ BL No", value : "m_awb_m_b_l" },
    ]
  };

const TrackingReport = () => {
  const [dataList, setDataList] = useState([]);
  const [serviceProvider, setServiceProvider] = useState(ProviderOption[0]);
  const [loader, setLoader] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(currentPage1);
  const [search, setSearch] = useState("");

  const getData = async (page, search , provider) => {
    setServiceProvider(provider)
    setSearch(search);
    setCurrentPage(page);
    let filter = { page: page, limit: pagination.limit };
    if (provider?.value && provider?.value !== "ALL") {
      filter = { ...filter, search1: provider?.value };
    }
    if (search) {
      filter = { ...filter, search: search };
    }  
    setLoader(true);
    trackingServices.getTrackingReport(filter).then((result) => {
      if (result.status === true) {
        setDataList(result.data.map((item)=> {
          return { ...item, job_status: providerObj[item.job_status] || item.job_status }
        }));
        setPagination({ ...pagination, ...result.pagination });
        setLoader(false);
      } else {
        setLoader(false);
      }
    });
  }
  
  useEffect(() => {
    getData(currentPage, "", ProviderOption[0]);
  }, []);



  const exportToExcel = () => {
    let params = {};
    if (serviceProvider?.value && serviceProvider?.value !== "ALL") {
      params["search1"] = serviceProvider?.value;
    }
    if (search) {
      params["search"] = search;
    }

    reportService.exportTrackingReport(params).then((result) => {
      if (result.status === true) {
        window.location.href = REACT_APP_API_BASEURL + "/" + result.data;
      } else {
        toast.error("Something went wrong");
      }
    });
  };
  

  const onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1;
    setLoader(true);
    getData(currentPage1, search, serviceProvider);
  };


  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-sm-3">
                <input
                  style={{ height: "38px" }}
                  type="text"
                  className={"form-control"}
                  placeholder="Search..."
                  onKeyUp={(e) => getData(1, e.target.value , serviceProvider)}
                />
              </div>
              <div className="col-sm-3">
                <Select
                  styles={{
                    valueContainer: (provided) => ({
                      ...provided,
                      height: "calc(2.15rem + 2px)",
                      overflowY: "visible",
                    }),
                    control: (provider) => ({
                      ...provider,
                      boxShadow: "0 0 0 0px #f46a6a",
                    }),
                    placeholder: (provider) => ({
                      ...provider,
                      color: "#a0b0ca",
                    }),
                  }}
                  onChange={(e) => getData(1, search , e)}
                  placeholder="Shipment Status"
                  options={ProviderOption}
                />
              </div>
              <div className="col-sm-6 text-end">
                <Button
                  className="ps-4 pe-4"
                  variant="success"
                  onClick={() => exportToExcel()}
                >
                  {" "}
                  Excel{" "}
                </Button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Sr No.</th>
                    <th>Job No.</th>
                    <th>Customer Name</th>
                    {tableheader[serviceProvider.value].map((item, index) => (
                      <th key={index}>{item.label}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {dataList.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td className="text-body fw-bold">
                          {(currentPage - 1) * pagination.limit + (index + 1)}
                        </td>
                        <td>{item?.job_token}</td>
                        <td>{item?.user_full_name}</td>
                        {tableheader[serviceProvider.value].map(
                          (item1, index1) => { 
                            let tVendor = ""
                            if(item1.type === "arr"){
                              const aset = new Set(item[item1.value])
                              tVendor =  [...aset].join(", ")
                            }
                            return(
                            <td key={index1}>
                              {item1.type === "date"
                                ? item[item1.value]
                                  ? moment(item[item1.value]).format(
                                      "DD-MM-YYYY"
                                    )
                                  : "-"
                                : item1.type === "arr"
                                ? tVendor
                                : item[item1.value] || "-"}
                            </td>

                        )}
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {dataList && dataList.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> list not available </h6>
                </div>
              )}

              {dataList &&
                dataList.length > 0 &&
                pagination.totalRecord > pagination.limit && (
                  <ReactPaginate
                    previousLabel={
                      <img
                        src="assets/images/prev.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    forcePage={currentPage - 1}
                    nextLabel={
                      <img
                        src="assets/images/next.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={Math.ceil(
                      pagination.totalRecord / pagination.limit
                    )}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={(e) => onPageChangeEvent(e)}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                  />
                )}
              <Loader isShow={loader} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrackingReport;
